import React from 'react';
import { Report } from 'cccisd-laravel-report';
import AccommodationsReport from '../Report';

const Component = props => {
    return (
        <div style={{ width: '840px', margin: '0 auto', maxWidth: '100%' }}>
            <Report downloadFilename="AccommodationsReport" height="600px">
                <AccommodationsReport {...props} />
            </Report>
        </div>
    );
};

export default Component;
